import getIn from 'transmute/getIn';
export const getInboxRequestStatus = getIn(['unifiedInbox', 'inboxRequestStatus']);